module.exports = __webpack_public_path__ + "static/media/5.a4ea8964.JPG";